import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Timeline, TimelineLite} from "gsap";
import {ImmortalFruits} from "../../ImmortalFruits";

/**
 * Created by jonas on 2020-05-18.
 */

export class ImmortalFruitsGambleBet {
    public stagger?:number = 0;
    private skipGamble:boolean = false;

    constructor() {
        ImmortalFruits.api.events.on("redirectingToBonusInGame", ()=>{
            this.skipGamble = true;
        });
        ImmortalFruits.api.events.on("redirectingToBonusInGameComplete", ()=>{
            this.skipGamble = false;
        })
    }

    public getAnimation(data:ParsedServerData):Timeline {
        const tl:TimelineLite = new TimelineLite();
        tl.add(()=>{
                if (SlotGame.gamblePlugin){
                    SlotGame.gamblePlugin.startGamble(this.skipGamble);
                }
                else {
                    throw new Error("SlotGame.gamblePlugin is undefined");
                }
            }
        );
        return tl;
    }
}